/**
 * Blocos comuns a todos os DTOs (paginação e o `uuid` reutilizado). É o arquivo
 * base da pasta: nenhum outro DTO pode ser importado daqui, para que a ordem de
 * import nunca feche um ciclo.
 */
import { z } from "zod";
import { LIMITS } from "../enums.js";

/* ---------- Comuns ---------- */
export const uuid = z.string().uuid();
export const cursorPage = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(LIMITS.PAGE_MAX).default(LIMITS.PAGE_DEFAULT),
});
export type CursorPage = z.infer<typeof cursorPage>;

export const pageInfo = z.object({
  nextCursor: z.string().nullable(),
  hasMore: z.boolean(),
});
export type PageInfo = z.infer<typeof pageInfo>;

/**
 * Envelope canônico de paginação (docs/09 §3.1): TODA lista paginada responde
 * `{ items, pageInfo }`. É o único formato aceito pelo web (D-01).
 */
export function paginated<T extends z.ZodTypeAny>(item: T) {
  return z.object({ items: z.array(item), pageInfo });
}
export type Paginated<T> = { items: T[]; pageInfo: PageInfo };
